export default __webpack_public_path__ + "static/media/verified.7667d8f6.png";